import * as Library from "../../../utils/Library";

// #region REQUESTS
export async function requestBuyingIntelPageData({
    pageType,
    buyingCycleID,
    companyID,
    setLoader,
    onError
}) {
    const res = await Library.makeApiRequest({
        endpoint: "getBuyingIntelData",
        data: {
            pageType,
            buyingCycleID,
            companyID
        },
        setLoader,
        onError
    });

    if (res?.data?.status !== 200) return undefined;
    return res?.data?.data ?? null;
}
// #endregion
